<template>
  <div>
    <CRow>
      <CCol
        v-for="(metric) in metrics.slice(0, 4)"
        :key="metric.id"
        sm="6"
        md="6"
        lg="6"
        xl="3"
        class="statistical-card__wrapper"
      >
        <VStatisticalCard
          :loading="loading"
          :title="metric.title"
          :value="metric.value"
          :chart-color="metric.theme"
          :chart-data="metric.chartData"
        />
      </CCol>
    </CRow>

    <CRow>
      <CCol
        v-for="(metric) in metrics.slice(4, 8)"
        :key="metric.id"
        sm="6"
        md="6"
        lg="6"
        xl="3"
        class="statistical-card__wrapper"
      >
        <VStatisticalCard
          :loading="loading"
          :title="metric.title"
          :value="metric.value"
          :chart-color="metric.theme"
          :chart-data="metric.chartData"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol>Time period</CCol>
    </CRow>
    <CRow>
      <CCol
        sm="3"
        md="3"
        lg="3"
        xl="3"
      >
        <CSelect
          horizontal
          :options="options"
          @update:value="onPeriodChange"
        />
      </CCol>
    </CRow>
    <CRow>
      <CCol class="statistical-card__wrapper">
        <VAuctionsStatisticalCard :labels="labels" />
      </CCol>
    </CRow>
    <CRow>
      <CCol class="statistical-card__wrapper">
        <VRevenueStatisticalCard :labels="labels" />
      </CCol>
    </CRow>
  </div>
</template>
<script>
import VAuctionsStatisticalCard from '@/components/Statistical/VAuctionsStatisticalCard'
import VRevenueStatisticalCard from '@/components/Statistical/VRevenueStatisticalCard'
import {
  createStatisticalMixin,
  statisticalStore
} from '@/mixins/statisticalMixin'
import LABELS from '@/utils/dashboardLabels'

export default {
  name: 'Dashboard',

  components: {
    VAuctionsStatisticalCard,
    VRevenueStatisticalCard
  },

  mixins: [
    createStatisticalMixin()
  ],

  data () {
    return {
      loading: false,
      options: [
        {
          value: 'week',
          label: 'Week'
        },
        {
          value: 'month',
          label: 'Month'
        },
        {
          value: 'year',
          label: 'Year'
        },
        {
          value: 'all',
          label: 'All time'
        }
      ],
      selectedOption: 'week'
    }
  },

  computed: {
    metrics () {
      const m = this[statisticalStore.getterTypes.GET_METRICS]
      return m.length === 0 ? [1, 2, 3, 4, 5, 6, 7, 8] : m
    },
    labels () {
      return LABELS[this.selectedOption]
    }
  },

  created () {
    this[statisticalStore.actionTypes.ACTION_JOIN_TO_DASHBOARD]()
    this.loadData()
  },

  destroyed () {
    this[statisticalStore.actionTypes.ACTION_CLEAN_METRICS]()
    this[statisticalStore.actionTypes.ACTION_CLEAN_CHARTS]()
  },

  methods: {
    async onPeriodChange (v) {
      try {
        await this[statisticalStore.actionTypes.ACTION_LOAD_CHARTS](v)
        this.selectedOption = v
      } catch (error) {
        console.log(error)
      }
    },
    async loadData () {
      this.loading = true

      try {
        await Promise.all([
          this[statisticalStore.actionTypes.ACTION_LOAD_METRICS](),
          this[statisticalStore.actionTypes.ACTION_LOAD_CHARTS](this.selectedOption)
        ])
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
